import { PlayerSizesTypes } from '../../../../common/store/store.types';
import { SITE_VARIABLES } from '../../../../common/styles/variables';

interface StylesObject {
  fullScreenIconStyle: { [key: string]: any };
  fullscreenIconWrapperStyle: { [key: string]: any };
  iconAndToolTipContainerStyle: { [key: string]: any };
}

const fullScreenIcon = {
  cursor: 'pointer',
  opacity: '0.7',
  color: SITE_VARIABLES.COLORS.WHITE,
  pointerEvents: 'auto',
  mobile: {
    display: 'flex',
  },
  medium: {
    margin: '0px 10px 0px 6px',
  },
  large: {
    margin: '0px 16px 0px 8px',
  },
  extraLarge: {
    margin: '0px 24px 0px 8px',
  },
  hover: {
    opacity: '1',
  },
  outsideControlsBarDesktop: {
    margin: '0px',
  },
};

const fullscreenIconWrapper = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
  width: '40px',
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
};

export const getFullScreenButtonStyleObject = (playerSize: PlayerSizesTypes, hovered: boolean, showAdControls: boolean, desktopMode: boolean, isRecirculationControls: boolean, outsideControlsBar?: boolean): StylesObject => {
  const mediumSize = playerSize === 'medium';
  const largeSize = playerSize === 'large';
  const extraLargeSize = playerSize === 'extraLarge';

  return (
    {
      fullScreenIconStyle: [
        fullScreenIcon,
        !desktopMode && fullScreenIcon.mobile,
        mediumSize && desktopMode && fullScreenIcon.medium,
        outsideControlsBar && desktopMode && fullScreenIcon.outsideControlsBarDesktop,
        outsideControlsBar && !desktopMode && fullScreenIcon.hover,
        largeSize && fullScreenIcon.large,
        extraLargeSize && fullScreenIcon.extraLarge,
        desktopMode && hovered && fullScreenIcon.hover,
        isRecirculationControls && fullScreenIcon.hover,
      ],
      fullscreenIconWrapperStyle: [
        fullscreenIconWrapper,
      ],
      iconAndToolTipContainerStyle: {
        ...iconAndToolTipContainer,
      },
    }
  );
};
